<script setup lang="ts">
import { reactive } from "vue";
import CampaignsList from "@/components/CampaignsList.vue";
import CreateCampaign from "@/components/CreateCampaign.vue";
import CreateUnique from "@/components/CreateUnique.vue";
import constant from "@/constant";
import type { PromotionCode } from "@/rvapi";

// todo search unique codes

const { ACTION_STATUS } = constant;

const initialDisplayStatusObj = {
  isDisplayMessage: false,
  status: "",
  message: "",
};

const displayStatusObj = reactive({ ...initialDisplayStatusObj });

const codeCreationSuccess = (code: PromotionCode) => {
  const message = "Code " + code.code + " has been created successfully";
  displayStatusMessage(ACTION_STATUS.SUCCESS, message);
};

const codeCreationFailure = () => {
  const message =
    "There was an issue in trying to generate the campaign code.Please try again.";
  displayStatusMessage(ACTION_STATUS.FAILURE, message);
};

const uniqueCodeCreationFailure = () => {
  const message =
    "There was an issue in trying to generate the unique code.Please try again.";
  displayStatusMessage(ACTION_STATUS.FAILURE, message);
};
const displayStatusMessage = (status: string, message: string): void => {
  displayStatusObj.isDisplayMessage = true;
  displayStatusObj.status = status;
  displayStatusObj.message = message;
  setTimeout(() => {
    reset();
  }, 4000);
};

const reset = () => {
  displayStatusObj.isDisplayMessage = false;
  displayStatusObj.status = "";
  displayStatusObj.message = "";
};
</script>

<template>
  <pn-toast
    :text="displayStatusObj.message"
    :appearance="displayStatusObj.status"
    class="notification"
    temporary
    closable
    :hide="!displayStatusObj.isDisplayMessage"
  ></pn-toast>
  <h1>Promotion codes</h1>

  <div class="segment">
    <CreateCampaign
      @codeCreated="codeCreationSuccess"
      @codeCreationFailed="codeCreationFailure"
    />
  </div>
  <div class="segment">
    <CreateUnique @codeCreationFailed="uniqueCodeCreationFailure" />
  </div>

  <div class="segment">
    <CampaignsList />
  </div>
</template>

<style lang="scss" scoped>
.notification {
  position: fixed;
  bottom: 12px;
  padding: 16px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
